import {modelFor,configuredModel,offsetLimit,offsetDescription,savedConfiguration,fitCheck,orderProperties,drawingSVG} from './vr-roll-core.js?v=20261103-offset-v2';

function init(root) {
  if(root.dataset.ready)return;
  const q=s=>root.querySelector(s),form=q('[data-roll-form]');
  if(!form)return;
  root.dataset.ready='true';
  const el=k=>form.elements.namedItem(k),button=q('[data-roll-submit]'),status=q('[data-roll-status]');
  let catalog;
  try {catalog=JSON.parse(q('[data-roll-catalog]').textContent);if(catalog.currency!=='GBP')throw new Error();}
  catch {status.textContent='Please open the product page to choose and order your bed.';return;}
  const money=n=>new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(n/100);
  let model=null,view='hero',busy=false,invalid=false,offsetInvalid=false;
  let viewer=null,viewerLoading=null,viewerFailed=false;
  try {
    const saved=savedConfiguration(new URL(location.href).searchParams,catalog.variants);
    el('width').value=String(saved.width);el('deckOffset').value=String(saved.offset);
  }catch {q('[data-roll-tool-status]').textContent='That saved bed or offset is invalid. Showing the standard ROLL 1000.';}
  function state(){
    button.disabled=busy||invalid||!model?.variant.available||!el('confirmed').checked;
    q('[data-roll-download]').disabled=busy||offsetInvalid||!model;
    q('[data-roll-share]').disabled=busy||offsetInvalid||!model;
  }
  function preview(){
    const render=q('[data-roll-render]'),drawing=q('[data-roll-drawing]'),hint=q('[data-roll-preview-hint]');
    root.querySelectorAll('[data-roll-view]').forEach(b=>{
      b.setAttribute('aria-pressed',String(b.dataset.rollView===view));
    });
    const useDrawing=view==='drawing'||viewerFailed;
    render.hidden=useDrawing;drawing.hidden=!useDrawing;
    q('[data-roll-camera]').hidden=useDrawing||!viewer;
    viewer?.visible(!useDrawing);
    if(useDrawing){
      drawing.innerHTML=drawingSVG(model);
      hint.textContent=viewerFailed&&view!=='drawing'?'3D preview is unavailable on this device. Your dimensioned drawing shows the selected offset.':'Plan and front view with your selected dimensions.';
      return;
    }
    if(viewer){viewer.update(model,view);hint.textContent='Drag to rotate, or use the view controls. The deck follows your chosen offset.';return;}
    render.replaceChildren();
    hint.textContent='Loading the detailed bed preview…';
    if(!viewerLoading){
      const fail=()=>{viewerFailed=true;preview();};
      viewerLoading=import('./vr-roll-preview.js?v=20261103-3d-v3')
        .then(module=>module.createRollPreview(render,{panels:root.dataset.panelsUrl,texture:root.dataset.textureUrl},fail))
        .then(result=>{viewer=result;if(!root.isConnected){viewer.dispose();return;}preview();})
        .catch(fail);
    }
  }
  function update(){
    if(busy)return;
    const width=Number(el('width').value),limit=offsetLimit(width);
    q('[data-roll-offset] input').disabled=width===1000;
    for(const k of ['deckOffset','offsetSlider']){el(k).min=String(-limit);el(k).max=String(limit);}
    q('[data-roll-offset-range]').textContent=`−${limit} to +${limit} mm for this width.`;
    q('[data-roll-layout-help]').textContent='Choose a starting layout, then adjust the deck offset below.';
    try {
      model=configuredModel(width,el('deckOffset').value===''?NaN:Number(el('deckOffset').value),catalog.variants);
      invalid=false;offsetInvalid=false;root.classList.remove('rb-offset-invalid');
      q('[data-roll-offset-error]').hidden=true;el('deckOffset').setAttribute('aria-invalid','false');
    }catch(err){
      invalid=true;offsetInvalid=true;root.classList.add('rb-offset-invalid');
      q('[data-roll-offset-error]').textContent=err.message+' The drawing shows the last valid offset.';
      q('[data-roll-offset-error]').hidden=false;el('deckOffset').setAttribute('aria-invalid','true');
      status.textContent='Check the deck offset above before adding to the basket.';state();return;
    }
    el('offsetSlider').value=String(model.offset);
    el('offsetSlider').setAttribute('aria-valuetext',offsetDescription(model.offset));
    el('layout').value=model.customOffset?'custom':model.layout;
    q('[data-roll-position]').textContent=offsetDescription(model.offset);
    const fit=fitCheck(model,el('spaceWidth').value,el('spaceLength').value);
    invalid=Boolean(fit.error||fit.tooSmall);const fitNode=q('[data-roll-fit]');fitNode.classList.toggle('rb-fit-warning',invalid);
    if(fit.error)fitNode.textContent=fit.error;
    else if(fit.tooSmall)fitNode.textContent='The open bed exceeds your entered space. Choose a smaller model or recheck your measurements before ordering.';
    else {const checks=[];if(fit.side!==null)checks.push(`${fit.side} mm total width remaining`);if(fit.end!==null)checks.push(`${fit.end} mm length remaining`);fitNode.textContent=checks.length?checks.join(' · ')+'. This compares the open footprint only; check wheel arches and movement separately.':'Enter either measurement to compare your space.';}
    for(const [selector,value] of [['title',model.title],['width',model.width+' mm'],['left',model.left+' mm'],['right',model.right+' mm'],['price',money(model.variant.price)],['delivered',money(model.variant.price+8000)],['order-model',model.title+' · '+offsetDescription(model.offset)+' · 18 mm natural plywood']])q(`[data-roll-${selector}]`).textContent=value;
    el('id').value=String(model.variant.id);
    q('[data-roll-product]').href=root.dataset.productUrl+'?variant='+model.variant.id;
    q('[data-roll-product]').textContent=model.customOffset?'View the base product details':'View full product details';
    button.querySelector('span').textContent=model.variant.available?'Add bed to basket':'Currently unavailable';
    status.textContent=invalid?'Check your available space above.':model.variant.available?'Your chosen offset, overhangs and notes will be saved in your basket.':'This model is currently unavailable. Please choose another model or contact us.';
    preview();state();
  }
  form.addEventListener('input',e=>{
    if(busy||['van','notes'].includes(e.target.name))return;
    if(e.target.name==='confirmed'){state();return;}
    if(e.target.type==='radio')return;
    if(e.target.name==='offsetSlider')el('deckOffset').value=e.target.value;
    update();
  });
  form.addEventListener('change',e=>{
    if(busy||e.target.type!=='radio')return;
    if(e.target.name==='width'){
      const width=Number(el('width').value),limit=offsetLimit(width);
      if(el('layout').value!=='custom'){
        const preset=modelFor(width,el('layout').value);el('deckOffset').value=String((preset.right-preset.left)/2);
      }else if(el('deckOffset').value!==''&&Number.isInteger(Number(el('deckOffset').value))){
        const old=Number(el('deckOffset').value),adjusted=Math.max(-limit,Math.min(limit,old));
        el('deckOffset').value=String(adjusted);
        if(adjusted!==old)q('[data-roll-tool-status]').textContent=`Offset adjusted to ${offsetDescription(adjusted).toLowerCase()} to keep the 900 mm base within the narrower bed.`;
      }
    }
    if(e.target.name==='layout'){
      if(e.target.value==='custom')el('deckOffset').value='0';
      else {const preset=modelFor(Number(el('width').value),e.target.value);el('deckOffset').value=String((preset.right-preset.left)/2);}
    }
    update();
  });
  root.addEventListener('click',async e=>{
    const cameraButton=e.target.closest('[data-roll-camera-action]');
    if(cameraButton&&viewer){const action=cameraButton.dataset.rollCameraAction;if(action==='reset')viewer.reset();else viewer.rotate(action==='left'?-1:1);}
    if(e.target.closest('[data-roll-centre]')&&!busy){el('deckOffset').value='0';update();}
    const viewButton=e.target.closest('[data-roll-view]');
    if(viewButton&&!viewButton.disabled){view=viewButton.dataset.rollView;if(model)preview();}
    if(e.target.closest('[data-roll-download]')&&model&&!offsetInvalid&&!busy){
      const url=URL.createObjectURL(new Blob([drawingSVG(model)],{type:'image/svg+xml'})),a=document.createElement('a');a.href=url;a.download=`roll-${model.width}-offset-${model.offset}mm-dimensions.svg`;document.body.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),30000);q('[data-roll-tool-status]').textContent='Dimensioned drawing downloaded with your chosen offset.';
    }
    if(e.target.closest('[data-roll-share]')&&model&&!offsetInvalid&&!busy){
      const url=new URL(location.href);url.search='';url.hash='';url.searchParams.set('model',model.key);url.searchParams.set('offset',String(model.offset));
      const out=q('[data-roll-tool-status]');out.replaceChildren();
      try {await navigator.clipboard.writeText(url.href);out.textContent='Link copied with your offset. Van details and notes are kept private.';}
      catch {out.textContent='Copy this link: ';const input=document.createElement('input');input.type='text';input.readOnly=true;input.value=url.href;input.setAttribute('aria-label','Link to this ROLL bed');out.append(input);input.select();}
    }
  });
  form.addEventListener('submit',async e=>{
    e.preventDefault();if(busy)return;update();
    if(invalid||!model?.variant.available||!el('confirmed').checked||!form.reportValidity())return;
    let properties;
    try {properties=orderProperties(model,el('van').value,el('notes').value);}catch(err){status.textContent=err.message;return;}
    busy=true;state();const controls=[...form.querySelectorAll('input,textarea,button')].map(input=>[input,input.disabled]);controls.forEach(([input])=>input.disabled=true);status.textContent='Adding your '+model.title+' to the basket…';
    try {
      const response=await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:model.variant.id,quantity:1,properties}]})});
      const result=await response.json();if(!response.ok)throw new Error(result.description||'The bed could not be added. Please view the product or contact us.');
      if(!result.items?.some(item=>Number(item.variant_id||item.id)===model.variant.id))throw new Error('Please check your basket before trying again.');
      location.assign(root.dataset.cartUrl);
    }catch(err){status.textContent=err instanceof TypeError?'The connection was interrupted. Check your basket before trying again to avoid adding the bed twice.':err.message;controls.forEach(([input,disabled])=>input.disabled=disabled);busy=false;state();}
  });
  update();
  document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root))viewer?.dispose();},{once:true});
}
document.querySelectorAll('[data-roll-configurator]').forEach(init);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-roll-configurator]').forEach(init));
